export default __webpack_public_path__ + "static/base-plus-4-7501f5c541c676b4e228b40e188c3f9a.jpg";